import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Table } from "antd";
import { useNavigate } from "react-router-dom";
import DelTableRowModal from "../../../modals/delTableRowModal";
import { useTranslation } from "react-i18next";
const data = [
  {
    key: "1",
    caseID: "C001",
    documentName: "Email Exchange.pdf",
    evidenceType: "Digital (Email)",
    dateSubmitted: "01-12-2023",
    witness: "Jane Smith",
    description: "Email exchange between client and defendant",
  },
  {
    key: "2",
    caseID: "C001",
    documentName: "Surveillance Footage.mp4",
    evidenceType: "Video",
    dateSubmitted: "15-11-2023",
    witness: "Mark Lee",
    description: "Security footage from the incident site",
  },
  {
    key: "3",
    caseID: "C001",
    documentName: "Bank Records.pdf",
    evidenceType: "Document",
    dateSubmitted: "08-05-2023",
    witness: "Sarah White",
    description: "Financial transactions related to the case",
  },
  {
    key: "4",
    caseID: "C001",
    documentName: "Email Exchange.pdf",
    evidenceType: "Digital (Email)",
    dateSubmitted: "06-03-2023",
    witness: "Jane Smith",
    description: "Email exchange between client and defendant",
  },
  {
    key: "5",
    caseID: "C001",
    documentName: "Surveillance Footage.mp4",
    evidenceType: "Video",
    dateSubmitted: "01-03-2023",
    witness: "Mark Lee",
    description: "Security footage from the incident site",
  },
  {
    key: "6",
    caseID: "C001",
    documentName: "Bank Records.pdf",
    evidenceType: "Document",
    dateSubmitted: "01-05-2023",
    witness: "Sarah White",
    description: "Financial transactions related to the case",
  },
];
const EvidenceTable = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isdelModalOpen, setIsdelModalOpen] = useState(false);
  const onDelClick = () => {
    setIsdelModalOpen(true);
  };
  const columns = [
    {
      title: t("dashboard.evidenceManagement.caseID"),
      dataIndex: "caseID",
      key: "caseID",
      render: (text) => <p className="text-darkGrey small font-poppins">{text}</p>,
    },
    {
      title: t("dashboard.evidenceManagement.documentName"),
      dataIndex: "documentName",
      key: "documentName",
      render: (documentName) => <p className="text-darkGrey small font-poppins">{documentName}</p>,
    },
    {
      title: t("dashboard.evidenceManagement.evidenceType"),
      dataIndex: "evidenceType",
      key: "evidenceType",
      render: (evidenceType) => <p className="text-darkGrey small font-poppins">{evidenceType}</p>,
    },
    {
      title: t("dashboard.evidenceManagement.dateSubmitted"),
      dataIndex: "dateSubmitted",
      key: "dateSubmitted",
      render: (dateSubmitted) => (
        <p className="text-darkGrey small font-poppins">{dateSubmitted}</p>
      ),
    },
    {
      title: t("dashboard.evidenceManagement.witness"),
      dataIndex: "witness",
      key: "witness",
      render: (witness) => <p className="text-darkGrey small font-poppins">{witness}</p>,
    },
    {
      title: t("dashboard.evidenceManagement.description"),
      dataIndex: "description",
      key: "description",
      render: (description) => <p className="text-darkGrey small font-poppins">{description}</p>,
    },
    {
      title: t("dashboard.evidenceManagement.actions"),
      key: "actions",
      render: () => (
        <div className="flex gap-[18px]">
          <p
            className="text-secondary cursor-pointer flex justify-center items-center small font-poppins w-[83px] h-[34px] bg-[#D3EFF4] rounded-[47px]"
            onClick={() => {
              navigate("/evidence/evidence-details");
            }}
          >
            {t("dashboard.evidenceManagement.details")}
          </p>
          <img
            src="../../assets/icons/del.png"
            alt=""
            className="cursor-pointer"
            onClick={onDelClick}
          />
        </div>
      ),
    },
  ];
  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        pagination={{
          position: ["bottomCenter"],
          pageSize: 6,
          itemRender: (current, type, originalElement) => {
            if (type === "prev") {
              return (
                <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                  <Icon icon="ep:arrow-left-bold" color="#143A62" />
                </div>
              );
            }
            if (type === "next") {
              return (
                <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                  <Icon icon="ep:arrow-right-bold" color="#143A62" />
                </div>
              );
            }
            return originalElement;
          },
          showSizeChanger: false,
          className: "custom-pagination",
        }}
        className="w-full"
        scroll={{ x: "1000px" }}
      />
      <DelTableRowModal isdelModalOpen={isdelModalOpen} setIsdelModalOpen={setIsdelModalOpen} />
    </>
  );
};

export default EvidenceTable;
